function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import WM_LOGOS from "constants/work-managment-logos";
import { StyledConnectedProductsGridComponent } from "./connected-products-grid-component.scss";
import GridImageWithParagraph from "segments/desktop/core-components/grid-image-with-paragraph/grid-image-with-paragraph";
import ConnectedProductsGridDefaultProps from "./default-props";
import PictureComponent from "/components/core/picture/picture-component";
const IMAGE_HEIGHT = "100%";
const IMAGE_WIDTH = "100%";
const WORK_MANAGEMENT_LOGO = WM_LOGOS.WM_PRODUCT_LOGO;
const PLUS_ICON_LINK = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/work%20management_new%20product%20page/products/plus_icon.png";
const ConnectedProductsGridComponent = (props)=>{
    const renderGridItems = ()=>{
        const { gridItems, textSize } = props;
        return gridItems === null || gridItems === void 0 ? void 0 : gridItems.map((gridItem, index)=>{
            const { fullParagraph } = gridItem, restImageProps = _object_without_properties(gridItem, [
                "fullParagraph"
            ]);
            return /*#__PURE__*/ _jsx("div", {
                className: "grid-image-with-paragraph-component-wrapper",
                children: /*#__PURE__*/ _jsx(GridImageWithParagraph, _object_spread_props(_object_spread({}, restImageProps), {
                    fullParagraph: fullParagraph,
                    width: IMAGE_WIDTH,
                    height: IMAGE_HEIGHT,
                    textSize: textSize,
                    hideButton: true
                }))
            }, index);
        });
    };
    return /*#__PURE__*/ _jsx(StyledConnectedProductsGridComponent, {
        className: "connected-products-grid-component",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "products-wrapper",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "work-management-icon",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: WORK_MANAGEMENT_LOGO,
                        alt: "monday work management"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "plus-icon",
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        src: PLUS_ICON_LINK
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "products",
                    children: renderGridItems()
                })
            ]
        })
    });
};
ConnectedProductsGridComponent.defaultProps = ConnectedProductsGridDefaultProps;
export default ConnectedProductsGridComponent;
